import { UserRoles } from 'src/utils/enums';

export const showSettings = (role: string) => {
  return role === UserRoles.ROLE_ADMIN || role === UserRoles.ROLE_SUPER_ADMIN;
};
